import { CommandType } from '../constants/Constants';
import UndoManager from '../manager/UndoManager';
import BaseCommand from './BaseCommand';

/**
 * 撤销命令
 *
 * @export
 * @class CmdUndo
 * @extends {BaseCommand}
 * @author zhenliang.sun
 */
export default class CmdUndo extends BaseCommand {
  constructor() {
    super();
    this.type = CommandType.Undo;
    this.executing = false;
  }

  execute() {
    super.execute();
    this.app.items.undo();
  }

  complete() {
    super.complete();
  }
}
